/**
 * Action types for reports params list functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle report params list.
 */

// Get report params type list constants
export const REPORT_PARAM_TYPE_REQUEST_GET = 'REPORT_PARAM_TYPE_REQUEST_GET';
export const REPORT_PARAM_TYPE_RESPONSE_GET_SUCCESS = 'REPORT_PARAM_TYPE_RESPONSE_GET_SUCCESS';
export const REPORT_PARAM_TYPE_RESPONSE_GET_FAIL = 'REPORT_PARAM_TYPE_RESPONSE_GET_FAIL';

// Get report params interval list constants
export const REPORT_PARAM_INTERVAL_REQUEST_GET = 'REPORT_PARAM_INTERVAL_REQUEST_GET';
export const REPORT_PARAM_INTERVAL_RESPONSE_GET_SUCCESS = 'REPORT_PARAM_INTERVAL_RESPONSE_GET_SUCCESS';
export const REPORT_PARAM_INTERVAL_RESPONSE_GET_FAIL = 'REPORT_PARAM_INTERVAL_RESPONSE_GET_FAIL';

// Get report params period list constants
export const REPORT_PARAM_PERIOD_REQUEST_GET = 'REPORT_PARAM_PERIOD_REQUEST_GET';
export const REPORT_PARAM_PERIOD_RESPONSE_GET_SUCCESS = 'REPORT_PARAM_PERIOD_RESPONSE_GET_SUCCESS';
export const REPORT_PARAM_PERIOD_RESPONSE_GET_FAIL = 'REPORT_PARAM_PERIOD_RESPONSE_GET_FAIL';
